import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { v4 as uuidv4 } from 'uuid';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';

export default function RichTextRow(props) {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'RichTextRow',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow(
			Object.assign(
				{
					mzTitle: 'MZ | Text SEO',
					blockClass: 'flex-row__rich-text-row-1',
					horizontalAlign: 'center',
				},
				props?.FlexLayoutRow || {},
			),
		).props,
		childrenComponents: [
			RichText(
				Object.assign(
					{
						text: 'Digite aqui seu texto em markdown',
						blockClass: 'rich-text__rich-text-row-1',
						textAlignment: 'CENTER',
						textPosition: 'CENTER',
					},
					props?.RichText || {},
				),
			),
		],
	};
}

//variables with type color, typography,fontsize mobile and desktop
const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--rtr-1-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--rtr-1-text-color', name: 'Text' },
		],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--rtr-1-typography', name: 'Text' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-sm', to: '--rtr-1-font-size', name: 'Text' },
			{ from: '--font-size-sm', to: '--rtr-1-font-size-mobile', name: 'Text Mobile' },
		],
	},
];
